import * as React from 'react';
import { observer } from 'mobx-react';
import { Page } from '../../components/atoms/layout/Page';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import './pricingPage.module.scss';
import { PricingSummary } from '../../components/organisms/trial/plan/PricingSummary';

@withNavigation(NavigationSpecs.standard())
@observer
export class PricingPage extends React.Component {
    render() {
        return (
            <Page styleName="page">
                <PageHeader title="Plan" subTitle="料金プラン" showOnMobile={true} />
                <PageBody styleName="body">
                    <PricingSummary />
                </PageBody>
            </Page>
        );
    }
}
